import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Global } from '../../../app.global';
import { GlobalObservables } from '../../../app.global.observer';
import { PcnBlockService } from '../../../shared/common/services/pcn-block.service';
import { SettingsService } from '../../../authentication/services/settings.service';
import { StorageService } from '../../../shared/common/services/storage.service';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { UserSettingsService } from '../../../shared/common/services/settings.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'reasons-layout',
  templateUrl: './reasons-layout.component.html',
  styleUrls: ['./reasons-layout.component.scss'],
})
export class ReasonsLayoutComponent implements OnInit, OnDestroy {
  @ViewChild('questionsBlock') questionsBlock: ElementRef;
  @ViewChild('reasonsContainer') reasonsContainer: ElementRef;

  isCustomLettersVisible = false;
  isCustomParagraphsVisible = false;
  isPcnPanelVisible = true;
  isLetterPanelVisible = false;
  isReasonsLayoutVisible = true;
  isPcnPanelLocked: boolean;
  isNexusEnabled = false;
  questionsVisible = true;
  globalNexusEnabled = false;
  userNexusEnabled = false;

  private onCustomParagraphsShowEvent: ISubscription;
  private onCustomLettersShowEvent: ISubscription;
  private onPcnToggleEvent: ISubscription;

  constructor(
    public global: Global,
    private pcnBlockService: PcnBlockService,
    private settingsService: SettingsService,
    private userSettingsService: UserSettingsService,
    public globalObs: GlobalObservables,
    private storageService: StorageService
  ) {
    this.isPcnPanelLocked = this.getPcnPanelLocked();
  }

  ngOnInit() {
    /* Subscribe to events */
    this.onCustomParagraphsShowEvent = this.globalObs.onCustomParagraphsShow.subscribe(
      (visibility: boolean) => this.onCustomParagraphsVisibilityChange(visibility)
    );
    this.onCustomLettersShowEvent = this.globalObs.onCustomLettersShow.subscribe(
      (visibility: boolean) => this.onCustomLettersVisibilityChange(visibility)
    );
    this.onPcnToggleEvent = this.globalObs.togglePcnPanel.subscribe((locked: string) =>
      this.onTogglePcnPanel(locked)
    );

    this.global.isPcnPinVisible = true;

    this.settingsService.getApplicationSetting('NexusEnabled').subscribe((result) => {
      this.globalNexusEnabled = this.checkNexusEnabled(result);
      this.isNexusEnabled = this.globalNexusEnabled && this.userNexusEnabled;
    });

    this.userSettingsService.getUserSetting('nexusEnabled').subscribe((result) => {
      this.userNexusEnabled = this.checkNexusEnabled(result);
      this.isNexusEnabled = this.globalNexusEnabled && this.userNexusEnabled;
    });

    this.isPcnPanelLocked = this.storageService.isPcnPanelLocked();
    this.global.setPcnPanelLocked(this.isPcnPanelLocked);
  }

  checkNexusEnabled(v: unknown): boolean {
    if (typeof v === 'string') {
      const s = v.trim().toLowerCase();
      return s === 'true' || s === '1';
    }
    if (typeof v === 'number') {
      return v === 1;
    }
    if (typeof v === 'boolean') {
      return v;
    }
    return false;
  }

  scrollToQuestions() {
    if (this.reasonsContainer.nativeElement && this.questionsBlock.nativeElement.offsetTop) {
      const scrollTop = this.questionsBlock.nativeElement.offsetTop + 30;
      this.reasonsContainer.nativeElement.scrollTo({
        top: scrollTop,
        behavior: 'smooth',
      });
    }
  }

  onCustomParagraphsVisibilityChange(visibility: boolean) {
    this.isCustomLettersVisible = false;
    this.isCustomParagraphsVisible = visibility;
  }

  onCustomLettersVisibilityChange(visibility: boolean) {
    this.isCustomParagraphsVisible = false;
    this.isCustomLettersVisible = visibility;
  }

  selectReasonsLayout(target) {
    if (target.classList.contains('letter-helper')) {
      this.isReasonsLayoutVisible = true;
    }
  }

  selectLetterLayout(target) {
    if (target.classList.contains('reasons-helper')) {
      this.isReasonsLayoutVisible = false;
    }
  }

  onPcnPanelLocked(locked: boolean) {
    this.isPcnPanelLocked = locked;
  }

  getPcnPanelLocked() {
    return this.pcnBlockService.checkPcnPanelLocked();
  }

  onTogglePcnPanel(option: string) {
    if (option === 'lock') {
      this.isPcnPanelLocked = true;
    } else if (option === 'unlock') {
      this.isPcnPanelLocked = false;
    }
  }

  ngOnDestroy() {
    this.onCustomParagraphsShowEvent?.unsubscribe();
    this.onCustomLettersShowEvent?.unsubscribe();
    this.onPcnToggleEvent?.unsubscribe();
  }
}
